import React from 'react';
import { useParams } from 'react-router-dom';

import { BancoLista } from 'Component/Banco';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useRecuperarBancosQuery } from 'View/Service/Default/Bancos';

const Bancos = (): React.ReactElement => {
  const { id = 0 } = useParams();

  const {
    data: { bancos, paginacao } = {},
    isFetching,
    isLoading,
    refetch,
  } = useRecuperarBancosQuery({
    options: { entidade: 'empresas', entidade_id: id },
  });

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
          <BotaoLink
            tema="success"
            icone="plus-lg"
            to={`/bancos/adicionar/empresas/${id}`}
          >
            Adicionar
          </BotaoLink>
        </div>
      </div>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={bancos?.length}
        redirecionar={`/bancos/adicionar/empresas/${id}`}
      />
      <div className="bg-white shadow-sm rounded">
        {bancos?.map((banco) => (
          <BancoLista
            key={`${banco.id}-${banco.modificado}`}
            dados={banco}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default Bancos;
